import React, { useEffect } from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
import SingleColumnLayout from "@components/Layout/SingleColumnLayout";
import { RenderCategories } from "@components/RenderCategories";
import { logErrorToAPI } from "src/utils/errorLogger";
import styles from "./Error404.module.css";

const AlgoliaSearch = dynamic(() => import("../AlgoliaSearch/AlgoliaSearch"));

const Error = (props) => {
  useEffect(() => {
    if (props?.error && Object.keys(props.error).length > 0) {
      logErrorToAPI(props.error, {
        type: "error-boundary",
        errorId: Date.now().toString(),
      });
    }
  }, [props?.error]);

  return (
    <div className={`${styles.container} topPadding`}>
      <div className={styles.header}>
        <h1 className={styles.title}>Oops!</h1>
        <h2 className={styles.subtitle}>{props.message || "That page is missing"}</h2>
      </div>
      <div className={styles.search}>
        <span className={styles.searchLabel}>Try Again</span>
        <AlgoliaSearch classes={styles.searchBox} />
        <p className={styles.backHome}>
          Back to <Link href="/">Home</Link>
        </p>
      </div>
      <div className={styles.bookCategory}>
        <div>
          <RenderCategories />
        </div>
        <div className={styles.bookContainer}>
          <img
            src={`${process.env.S3_IMAGE_URL}/book.png`}
            className={styles.bookImage}
            alt="error"
          />
        </div>
      </div>
    </div>
  );
};

Error.Layout = SingleColumnLayout;
Error.displayName = "error";

export default Error;
